const datasetDataManagementActions = {
  CLOSE_DATASET_DATA_MANAGEMENT: 'CLOSE_DATASET_DATA_MANAGEMENT',
  CONVERT_DATASET_DATA: 'CONVERT_DATASET_DATA',
  CONVERT_DATASET_DATA_SUCCESS: 'CONVERT_DATASET_DATA_SUCCESS',
  CONVERT_DATASET_DATA_ERROR: 'CONVERT_DATASET_DATA_ERROR',
  CONVERT_DICTIONARY_DATA: 'CONVERT_DICTIONARY_DATA',
  CONVERT_DICTIONARY_DATA_SUCCESS: 'CONVERT_DICTIONARY_DATA_SUCCESS',
  CONVERT_DICTIONARY_DATA_ERROR: 'CONVERT_DICTIONARY_DATA_ERROR',
  HIDE_VALIDATE_DATA_RESULTS_DIALOG: 'HIDE_VALIDATE_DATA_RESULTS_DIALOG',
  HIDE_VALIDATE_DICTIONARY_DATA_STATUS: 'HIDE_VALIDATE_DICTIONARY_DATA_STATUS',
  HIDE_VALIDATION_SERVER_ERRORS: 'HIDE_VALIDATION_SERVER_ERRORS',
  SHOW_VALIDATE_DICTIONARY_DATA_STATUS: 'SHOW_VALIDATE_DICTIONARY_DATA_STATUS',
  VALIDATE_DATASET_DATA: 'VALIDATE_DATASET_DATA',
  VALIDATE_DATASET_DATA_SUCCESS: 'VALIDATE_DATASET_DATA_SUCCESS',
  VALIDATE_DATASET_DATA_ERROR: 'VALIDATE_DATASET_DATA_ERROR',
  VALIDATE_DICTIONARY_DATA: 'VALIDATE_DICTIONARY_DATA',
  VALIDATE_DICTIONARY_DATA_SUCCESS: 'VALIDATE_DICTIONARY_DATA_SUCCESS',
  VALIDATE_DICTIONARY_DATA_ERROR: 'VALIDATE_DICTIONARY_DATA_ERROR',
};

export const dataValidationErrorTypes = {
  CONNECTION_ERROR: 'connection_error',
  DATA_ONLY_FIELD: 'data_only_field',
  DICTIONARY_ONLY_FIELD: 'dictionary_only_field',
  TABLE_NOT_FOUND: 'table_not_found',
  TYPE_MISMATCH: 'type_mismatch',
};

export const dataValidationFieldErrors = [
  dataValidationErrorTypes.TYPE_MISMATCH,
  dataValidationErrorTypes.DICTIONARY_ONLY_FIELD,
  dataValidationErrorTypes.DATA_ONLY_FIELD,
];

export default datasetDataManagementActions;
